import React from 'react';

const Stores = () => {
    return (
        <div>
            <h1 className="text-center">Stores</h1>
        </div>
    )
}

export default Stores;